module.exports = window["Bernie_l10nBundle_lt_LT"];